import React from 'react';
import { Typography } from '@mui/material';

import { MerchantAwareLink } from '../../../components/core/MerchantAwareLink';
import type { StoreReadiness } from '../../../store/modules/merchant/types';
import { agentHubPaths } from '../../../util/constants';
import { needsCatalogSync } from '../storeReadiness';
import { AgentHubWarningBanner } from './AgentHubWarningBanner';

type Props = {
  storeReadiness?: StoreReadiness | null;
  showLink?: boolean;
};

export const CatalogSyncReadinessNotice = ({
  storeReadiness,
  showLink = false,
}: Props): JSX.Element | null => {
  if (!needsCatalogSync(storeReadiness)) {
    return null;
  }

  return (
    <AgentHubWarningBanner testId="ella-catalog-sync-readiness-notice">
      Your catalog has never been synced before.{' '}
      {showLink ? (
        <Typography
          component={MerchantAwareLink}
          to={agentHubPaths.CATALOG}
          data-testid="ella-catalog-sync-readiness-link"
          sx={{
            display: 'inline',
            color: 'warning.dark',
            fontWeight: 700,
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
          }}
        >
          Complete catalog sync
        </Typography>
      ) : (
        <Typography component="span" sx={{ color: 'warning.dark', fontWeight: 700 }}>
          Complete catalog sync
        </Typography>
      )}{' '}
      to go live.
    </AgentHubWarningBanner>
  );
};
